<rt-dropdown-item
  [hasHoverEffect]="false"
  [class.disabled]="disabled"
  [class.clickable]="clickable && !disabled"
  [class.current]="isCurrent"
  (click)="!disabled && clickable ? stageClick.emit() : $event.stopPropagation()"
  [rtTooltipEnabled]="!!tooltipCopy && !isCurrent"
  [rtTooltip]="tooltipCopy"
  [rtTooltipMaxWidth]="220"
  rtTooltipPosition="left"
  [attr.data-cy]="!!tooltipCopy ? 'candidate-stage-menu:stage-item:has-tooltip' : null"
>
  <rt-icon
    prefix
    [name]="isCurrent ? 'radio-button-checked-bg' : 'radio-button-unchecked-bg'"
    [colorToken]="checkedIconToken"
    class="stage-icon"
  />
  <div layout-vertical>
    <div layout-horizontal layout-space-between layout-align-items-center class="wrapper">
      <div class="item-title">
        {{ title }}
      </div>
    </div>
    @if (description) {
      <div class="info-dropdown-text">
        {{ description }}
      </div>
    }
  </div>

  @if (showHiredIcon) {
    <rt-icon
      [rtTooltip]="'app.candidate.mark_as_hired' | translate"
      [colorToken]="actionIconToken"
      name="hired"
      size="small"
      suffix
    ></rt-icon>
  }
  @if (unbiasedHiringEnabled) {
    <rt-icon
      [rtTooltip]="'app.stages.unbiased_hiring' | translate"
      [colorToken]="actionIconToken"
      name="visibility-off"
      size="small"
      class="action-icon"
      suffix
    ></rt-icon>
  }
  @if (timeLimit) {
    <rt-icon
      [rtTooltip]="
        'app.overdue_candidates.x_proceed_to_stage_tooltip'
          | translate: { count: timeLimit | rtSecondsInDays }
      "
      [colorToken]="actionIconToken"
      [rtTooltipHasTextAlignCenter]="true"
      [rtTooltipMaxWidth]="230"
      (click)="$event.stopPropagation()"
      size="small"
      name="account-clock"
      class="action-icon"
      suffix
    ></rt-icon>
  }
  @if (hasAutomatedActions) {
    <rt-icon
      [colorToken]="actionIconToken"
      [rtTooltip]="'app.automated_actions.automated_actions' | translate"
      name="automated-actions"
      size="small"
      (click)="$event.stopPropagation(); showDetailsClick.emit()"
      class="action-icon"
      suffix
    ></rt-icon>
  }
</rt-dropdown-item>
